import { render, staticRenderFns } from "./AddPropRule.vue?vue&type=template&id=2554a11a&scoped=true"
import script from "./AddPropRule.vue?vue&type=script&lang=js"
export * from "./AddPropRule.vue?vue&type=script&lang=js"
import style0 from "./AddPropRule.vue?vue&type=style&index=0&id=2554a11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554a11a",
  null
  
)

export default component.exports